<template>
    <section id="clients">
        <div class="container">
            <h2>Naši klienti</h2>
            <f7-row>
                <f7-col>
                    <img data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="" src="../assets/logo_pedf.png"
                        alt="UK PEDF">
                </f7-col>
                <f7-col>
                    <img data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="500" src="../assets/logo_cvut.jpg"
                        alt="UK PEDF">
                </f7-col>
                <f7-col>
                    <img data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="" src="../assets/logo_finetika.png"
                        alt="UK PEDF">
                </f7-col>
                <f7-col>
                    <img data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="600" src="../assets/logo_vov.png"
                        alt="UK PEDF">
                </f7-col>
            </f7-row>
            <br>
            <br>
            <f7-row>
                <f7-col>
                    <img data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="" src="../assets/logo_nidv.png"
                        alt="NIDV">
                </f7-col>
                <f7-col>
                    <img data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="200" src="../assets/logo_grit.png"
                        alt="GRIT">
                </f7-col>
            </f7-row>
        </div>
    </section>
</template>

<script>
    export default {

    }
</script>

<style>
    #clients {
        background-color: #f7f7f8;
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    }

    #clients img {
        max-height: 150px;
        max-width: 200px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }

    .container {
        padding: 20px;
    }
</style>